// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --ta-bg-primary: var(--theme-bg-primary);
  --ta-bg-secondary: var(--theme-bg-secondary);
  --ta-bg-tertiary: var(--theme-bg-tertiary);
  --ta-bg-white: var(--theme-bg-primary);
  --ta-bg-hover: var(--theme-hover-bg);
  --ta-bg-muted: var(--theme-bg-muted);
  --ta-text-primary: var(--theme-text-primary);
  --ta-text-secondary: var(--theme-text-secondary);
  --ta-text-tertiary: var(--theme-text-tertiary);
  --ta-text-dark: var(--theme-text-primary);
  --ta-text-muted: var(--theme-text-muted);
  --ta-text-light: var(--theme-text-disabled);
  --ta-text-white: var(--theme-primary-contrast);
  --ta-border-primary: var(--theme-border-primary);
  --ta-border-secondary: var(--theme-border-secondary);
  --ta-blue-50: var(--theme-primary-soft);
  --ta-blue-100: var(--theme-primary-soft);
  --ta-blue-500: var(--theme-primary);
  --ta-blue-600: var(--theme-primary-hover);
  --ta-blue-700: var(--theme-primary-active);
  --ta-bg-blue-light: var(--theme-primary-soft);
  --ta-bg-blue-gradient-start: var(--theme-primary-soft);
  --ta-bg-blue-gradient-end: var(--theme-primary-soft);
  --ta-border-dark: var(--theme-border-primary);
  --ta-text-dark-secondary: var(--theme-text-secondary);
  --ta-error: var(--theme-danger);
  --ta-error-dark: var(--theme-danger);
  --ta-error-light: var(--theme-danger-bg);
  --ta-warning: var(--theme-warning);
  --ta-warning-dark: var(--theme-warning);
  --ta-warning-darker: var(--theme-warning);
}

.tasksContainerMain {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--theme-bg-primary);
  background: var(--ta-bg-primary);
  color: var(--theme-text-primary);
  color: var(--ta-text-primary);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  container-type: inline-size;
}

.tasksLayoutSplit {
  display: flex;
  flex: 1 1;
  min-height: 0;
  position: relative;
}
.tasksLayoutSplit.tasksLayoutSplitNoSidebar .tasksMainView:not(.tasksMainViewConstrained) {
  width: 100%;
  max-width: 100%;
}

.tasksBtnPrimary {
  background: var(--theme-primary);
  background: var(--ta-blue-500);
  color: var(--theme-primary-contrast);
  color: var(--ta-text-white);
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.tasksBtnPrimary:hover {
  background: var(--theme-primary-hover);
  background: var(--ta-blue-600);
}
.tasksBtnPrimary:disabled {
  background: var(--theme-border-secondary);
  background: var(--ta-border-secondary);
  color: var(--theme-text-tertiary);
  color: var(--ta-text-tertiary);
  cursor: not-allowed;
}

.tasksBtnSecondary {
  background: var(--theme-bg-tertiary);
  background: var(--ta-bg-tertiary);
  color: var(--theme-text-primary);
  color: var(--ta-text-primary);
  border: 1px solid var(--theme-border-secondary);
  border: 1px solid var(--ta-border-secondary);
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
}
.tasksBtnSecondary:hover {
  background: var(--theme-border-primary);
  background: var(--ta-border-primary);
  border-color: var(--theme-text-tertiary);
  border-color: var(--ta-text-tertiary);
}

.tasksBtnIconSecondary {
  color: var(--theme-text-secondary);
  color: var(--ta-text-secondary);
  padding: 4px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.15s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tasksBtnIconSecondary:hover {
  background: var(--theme-border-primary);
  background: var(--ta-border-primary);
  color: var(--theme-text-primary);
  color: var(--ta-text-primary);
}
.tasksBtnIconSecondary.active {
  background: var(--theme-border-primary);
  background: var(--ta-border-primary);
  color: var(--theme-text-primary);
  color: var(--ta-text-primary);
}

.tasksBtnIconSquare {
  background: transparent;
  color: var(--theme-text-secondary);
  color: var(--ta-text-secondary);
  border: 1px solid var(--theme-border-primary);
  border: 1px solid var(--ta-border-primary);
  padding: 6px;
  border-radius: 6px;
  border-radius: var(--radius-sm, 6px);
  cursor: pointer;
  transition: background 0.12s ease, color 0.12s ease, border-color 0.12s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.tasksBtnIconSquare:hover {
  background: var(--theme-hover-bg);
  background: var(--ta-bg-hover);
  color: var(--theme-text-primary);
  color: var(--ta-text-primary);
  border-color: var(--theme-border-secondary);
  border-color: var(--ta-border-secondary);
}
.tasksBtnIconSquare:active {
  background: var(--theme-bg-tertiary);
  background: var(--ta-bg-tertiary);
}

.tasksStateLoading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 24px;
  text-align: center;
}

.tasksLoadingSpinner {
  width: 32px;
  height: 32px;
  border: 3px solid var(--theme-border-primary);
  border: 3px solid var(--ta-border-primary);
  border-top: 3px solid var(--theme-primary);
  border-top: 3px solid var(--ta-blue-500);
  border-radius: 50%;
  animation: tasksSpinAnimation 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes tasksSpinAnimation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.tasksStateError {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 24px;
  text-align: center;
}

.tasksIconError {
  font-size: 48px;
  margin-bottom: 16px;
}

.tasksStateEmpty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 24px;
  text-align: center;
}

.tasksEmptyIcon {
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.5;
}

.tasksEmptyTitle {
  font-size: 20px;
  font-weight: 600;
  color: var(--theme-text-primary);
  color: var(--ta-text-dark);
  margin: 0 0 8px 0;
}

.tasksEmptyMessage {
  font-size: 16px;
  color: var(--theme-text-secondary);
  color: var(--ta-text-secondary);
  margin: 0;
  line-height: 1.5;
}

.tasksTextPrimary {
  color: var(--theme-text-primary);
  color: var(--ta-text-primary);
}

.tasksTextSecondary {
  color: var(--theme-text-secondary);
  color: var(--ta-text-secondary);
}

.tasksIcon {
  display: flex;
  align-items: center;
  justify-content: center;
}

@keyframes dropdownAppear {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@container (max-width: 800px) {
  .tasksLayoutSplit {
    flex-direction: row;
  }
  .tasksSidebar {
    width: 40px;
    padding: 16px 8px;
    border-right: 1px solid var(--theme-border-primary);
    border-right: 1px solid var(--ta-border-primary);
    border-bottom: none;
    max-height: none;
  }
  .tasksSidebarSectionTitle {
    display: none;
  }
  .tasksSidebarItem {
    padding: 8px;
    margin: 0 4px;
    justify-content: center;
  }
  .tasksSidebarItemIcon {
    margin-right: 0;
  }
  .tasksSidebarItemContent {
    display: none;
  }
  .tasksHeaderTop {
    flex-direction: row;
    gap: 12px;
    align-items: flex-start;
  }
  .tasksHeaderSubtitle {
    display: none;
  }
  .tasksHeaderActions {
    margin-left: 16px;
    justify-content: flex-end;
    flex-wrap: nowrap;
  }
  .tasksSearchContainer {
    width: auto;
    order: 0;
  }
  .tasksSearchInput {
    width: 40px;
    overflow: hidden;
    transition: width 0.3s ease;
  }
  .tasksSearchInput:focus-within {
    width: 200px;
  }
  .tasksSearchInput:not(:focus-within) .tasksInputSearch {
    padding: 8px 12px;
    background: transparent;
    border: 1px solid transparent;
    cursor: pointer;
  }
  .tasksSearchInput:not(:focus-within) .tasksInputSearch::placeholder {
    color: transparent;
  }
  .tasksSearchInput:not(:focus-within) .tasksSearchClear {
    display: none;
  }
  .tasksInputSearch {
    padding: 8px 36px 8px 12px;
    width: 100%;
    display: block;
  }
  .tasksSearchIcon {
    left: 12px;
    z-index: 2;
  }
  .tasksSearchClear {
    right: 8px;
  }
  .tasksBtnIconSquare {
    order: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/apps/TasksApp/TasksApp.scss"],"names":[],"mappings":"AAKA;EAEE,wCAAA;EACA,4CAAA;EACA,0CAAA;EACA,sCAAA;EACA,oCAAA;EACA,oCAAA;EAGA,4CAAA;EACA,gDAAA;EACA,8CAAA;EACA,yCAAA;EACA,wCAAA;EACA,2CAAA;EACA,8CAAA;EAGA,gDAAA;EACA,oDAAA;EAGA,uCAAA;EACA,wCAAA;EACA,mCAAA;EACA,yCAAA;EACA,0CAAA;EAGA,6CAAA;EACA,sDAAA;EACA,oDAAA;EAGA,6CAAA;EACA,qDAAA;EAGA,+BAAA;EACA,oCAAA;EACA,wCAAA;EACA,kCAAA;EACA,uCAAA;EACA,yCAAA;AAjBF;;AAqBA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,mCAAA;EAAA,gCAAA;EACA,gCAAA;EAAA,6BAAA;EACA,8EAAA;EACA,2BAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;AAlBF;AAqBI;EACE,WAAA;EACA,eAAA;AAnBN;;AAyBA;EACE,gCAAA;EAAA,8BAAA;EACA,oCAAA;EAAA,2BAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,uCAAA;AAtBF;AAwBE;EACE,sCAAA;EAAA,8BAAA;AAtBJ;AAyBE;EACE,yCAAA;EAAA,sCAAA;EACA,iCAAA;EAAA,8BAAA;EACA,mBAAA;AAvBJ;;AA2BA;EACE,oCAAA;EAAA,iCAAA;EACA,gCAAA;EAAA,6BAAA;EACA,+CAAA;EAAA,4CAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;AAxBF;AA0BE;EACE,uCAAA;EAAA,oCAAA;EACA,wCAAA;EAAA,qCAAA;AAxBJ;;AA4BA;EAEE,kCAAA;EAAA,+BAAA;EAEA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA3BF;AA6BE;EACE,uCAAA;EAAA,oCAAA;EACA,gCAAA;EAAA,6BAAA;AA3BJ;AA8BE;EACE,uCAAA;EAAA,oCAAA;EACA,gCAAA;EAAA,6BAAA;AA5BJ;;AAgCA;EACE,uBAAA;EACA,kCAAA;EAAA,+BAAA;EACA,6CAAA;EAAA,0CAAA;EACA,YAAA;EACA,kBAAA;EAAA,oCAAA;EACA,eAAA;EACA,4EAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AA7BF;AA+BE;EACE,iCAAA;EAAA,8BAAA;EACA,gCAAA;EAAA,6BAAA;EACA,2CAAA;EAAA,wCAAA;AA7BJ;AAgCE;EACE,oCAAA;EAAA,iCAAA;AA9BJ;;AAoCA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AAjCF;;AAoCA;EACE,WAAA;EACA,YAAA;EACA,6CAAA;EAAA,0CAAA;EACA,0CAAA;EAAA,wCAAA;EACA,kBAAA;EACA,gDAAA;EACA,mBAAA;AAjCF;;AAoCA;EACE;IAAK,uBAAA;EAhCL;EAiCA;IAAO,yBAAA;EA9BP;AACF;AAgCA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AA9BF;;AAiCA;EACE,eAAA;EACA,mBAAA;AA9BF;;AAiCA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AA9BF;;AAiCA;EACE,eAAA;EACA,mBAAA;EACA,YAAA;AA9BF;;AAiCA;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EAAA,0BAAA;EACA,iBAAA;AA9BF;;AAiCA;EACE,eAAA;EACA,kCAAA;EAAA,+BAAA;EACA,SAAA;EACA,gBAAA;AA9BF;;AAkCA;EACE,gCAAA;EAAA,6BAAA;AA/BF;;AAkCA;EACE,kCAAA;EAAA,+BAAA;AA/BF;;AAkCA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AA/BF;;AAmCA;EACE;IACE,UAAA;IACA,2BAAA;EAhCF;EAkCA;IACE,UAAA;IACA,wBAAA;EAhCF;AACF;AAqCA;EACE;IACE,mBAAA;EAnCF;EAsCA;IACE,WAAA;IACA,iBAAA;IACA,mDAAA;IAAA,gDAAA;IACA,mBAAA;IACA,gBAAA;EApCF;EAuCA;IACE,aAAA;EArCF;EAwCA;IACE,YAAA;IACA,aAAA;IACA,uBAAA;EAtCF;EAyCA;IACE,eAAA;EAvCF;EA0CA;IACE,aAAA;EAxCF;EA2CA;IACE,mBAAA;IACA,SAAA;IACA,uBAAA;EAzCF;EA4CA;IACE,aAAA;EA1CF;EA6CA;IACE,iBAAA;IACA,yBAAA;IACA,iBAAA;EA3CF;EA8CA;IACE,WAAA;IACA,QAAA;EA5CF;EA+CA;IACE,WAAA;IACA,gBAAA;IACA,2BAAA;EA7CF;EA+CE;IACE,YAAA;EA7CJ;EAiDI;IACE,iBAAA;IACA,uBAAA;IACA,6BAAA;IACA,eAAA;EA/CN;EAiDM;IACE,kBAAA;EA/CR;EAmDI;IACE,aAAA;EAjDN;EAsDA;IACE,0BAAA;IACA,WAAA;IACA,cAAA;EApDF;EAuDA;IACE,UAAA;IACA,UAAA;EArDF;EAwDA;IACE,UAAA;EAtDF;EAyDA;IACE,QAAA;EAvDF;AACF","sourcesContent":["// === TASKS APP STYLES ===\n// Following flat structure pattern with 'ta' prefix (TasksApp)\n\n// === COLOR VARIABLES ===\n// Map ta-* aliases to River theme tokens so the app responds to theme switching\n:root {\n  // Background colors\n  --ta-bg-primary: var(--theme-bg-primary);\n  --ta-bg-secondary: var(--theme-bg-secondary);\n  --ta-bg-tertiary: var(--theme-bg-tertiary);\n  --ta-bg-white: var(--theme-bg-primary);\n  --ta-bg-hover: var(--theme-hover-bg);\n  --ta-bg-muted: var(--theme-bg-muted);\n\n  // Text colors\n  --ta-text-primary: var(--theme-text-primary);\n  --ta-text-secondary: var(--theme-text-secondary);\n  --ta-text-tertiary: var(--theme-text-tertiary);\n  --ta-text-dark: var(--theme-text-primary);\n  --ta-text-muted: var(--theme-text-muted);\n  --ta-text-light: var(--theme-text-disabled);\n  --ta-text-white: var(--theme-primary-contrast);\n\n  // Border colors\n  --ta-border-primary: var(--theme-border-primary);\n  --ta-border-secondary: var(--theme-border-secondary);\n\n  // Brand colors (Blue)\n  --ta-blue-50: var(--theme-primary-soft);\n  --ta-blue-100: var(--theme-primary-soft);\n  --ta-blue-500: var(--theme-primary);\n  --ta-blue-600: var(--theme-primary-hover);\n  --ta-blue-700: var(--theme-primary-active);\n\n  // Special blue backgrounds (dropdowns, expanded items, active states)\n  --ta-bg-blue-light: var(--theme-primary-soft);\n  --ta-bg-blue-gradient-start: var(--theme-primary-soft);\n  --ta-bg-blue-gradient-end: var(--theme-primary-soft);\n\n  // Border and text for dropdown popovers\n  --ta-border-dark: var(--theme-border-primary);\n  --ta-text-dark-secondary: var(--theme-text-secondary);\n\n  // State colors\n  --ta-error: var(--theme-danger);\n  --ta-error-dark: var(--theme-danger);\n  --ta-error-light: var(--theme-danger-bg);\n  --ta-warning: var(--theme-warning);\n  --ta-warning-dark: var(--theme-warning);\n  --ta-warning-darker: var(--theme-warning);\n}\n\n// === LAYOUT CONTAINERS ===\n.tasksContainerMain {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: var(--ta-bg-primary);\n  color: var(--ta-text-primary);\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  container-type: inline-size;\n}\n\n.tasksLayoutSplit {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n  position: relative;\n\n  &.tasksLayoutSplitNoSidebar {\n    .tasksMainView:not(.tasksMainViewConstrained) {\n      width: 100%;\n      max-width: 100%;\n    }\n  }\n}\n\n// === BUTTONS ===\n.tasksBtnPrimary {\n  background: var(--ta-blue-500);\n  color: var(--ta-text-white);\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n\n  &:hover {\n    background: var(--ta-blue-600);\n  }\n\n  &:disabled {\n    background: var(--ta-border-secondary);\n    color: var(--ta-text-tertiary);\n    cursor: not-allowed;\n  }\n}\n\n.tasksBtnSecondary {\n  background: var(--ta-bg-tertiary);\n  color: var(--ta-text-primary);\n  border: 1px solid var(--ta-border-secondary);\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s ease;\n\n  &:hover {\n    background: var(--ta-border-primary);\n    border-color: var(--ta-text-tertiary);\n  }\n}\n\n.tasksBtnIconSecondary {\n  \n  color: var(--ta-text-secondary);\n  // border: 1px solid var(--ta-border-secondary);\n  padding: 4px;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &:hover {\n    background: var(--ta-border-primary);\n    color: var(--ta-text-primary);\n  }\n\n  &.active {\n    background: var(--ta-border-primary);\n    color: var(--ta-text-primary);\n  }\n}\n\n.tasksBtnIconSquare {\n  background: transparent;\n  color: var(--ta-text-secondary);\n  border: 1px solid var(--ta-border-primary);\n  padding: 6px;\n  border-radius: var(--radius-sm, 6px);\n  cursor: pointer;\n  transition: background 0.12s ease, color 0.12s ease, border-color 0.12s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n\n  &:hover {\n    background: var(--ta-bg-hover);\n    color: var(--ta-text-primary);\n    border-color: var(--ta-border-secondary);\n  }\n\n  &:active {\n    background: var(--ta-bg-tertiary);\n  }\n}\n\n\n// === STATES ===\n.tasksStateLoading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 64px 24px;\n  text-align: center;\n}\n\n.tasksLoadingSpinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid var(--ta-border-primary);\n  border-top: 3px solid var(--ta-blue-500);\n  border-radius: 50%;\n  animation: tasksSpinAnimation 1s linear infinite;\n  margin-bottom: 16px;\n}\n\n@keyframes tasksSpinAnimation {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.tasksStateError {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 64px 24px;\n  text-align: center;\n}\n\n.tasksIconError {\n  font-size: 48px;\n  margin-bottom: 16px;\n}\n\n.tasksStateEmpty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 64px 24px;\n  text-align: center;\n}\n\n.tasksEmptyIcon {\n  font-size: 48px;\n  margin-bottom: 16px;\n  opacity: 0.5;\n}\n\n.tasksEmptyTitle {\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--ta-text-dark);\n  margin: 0 0 8px 0;\n}\n\n.tasksEmptyMessage {\n  font-size: 16px;\n  color: var(--ta-text-secondary);\n  margin: 0;\n  line-height: 1.5;\n}\n\n// === TEXT STYLES ===\n.tasksTextPrimary {\n  color: var(--ta-text-primary);\n}\n\n.tasksTextSecondary {\n  color: var(--ta-text-secondary);\n}\n\n.tasksIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n// Shared animation used by FieldDropdown and ViewMenu\n@keyframes dropdownAppear {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n// === RESPONSIVE ===\n// Narrow containers: icon-only sidebar + collapsed search\n@container (max-width: 800px) {\n  .tasksLayoutSplit {\n    flex-direction: row;\n  }\n\n  .tasksSidebar {\n    width: 40px;\n    padding: 16px 8px;\n    border-right: 1px solid var(--ta-border-primary);\n    border-bottom: none;\n    max-height: none;\n  }\n\n  .tasksSidebarSectionTitle {\n    display: none;\n  }\n\n  .tasksSidebarItem {\n    padding: 8px;\n    margin: 0 4px;\n    justify-content: center;\n  }\n\n  .tasksSidebarItemIcon {\n    margin-right: 0;\n  }\n\n  .tasksSidebarItemContent {\n    display: none;\n  }\n\n  .tasksHeaderTop {\n    flex-direction: row;\n    gap: 12px;\n    align-items: flex-start;\n  }\n\n  .tasksHeaderSubtitle {\n    display: none;\n  }\n\n  .tasksHeaderActions {\n    margin-left: 16px;\n    justify-content: flex-end;\n    flex-wrap: nowrap;\n  }\n\n  .tasksSearchContainer {\n    width: auto;\n    order: 0;\n  }\n\n  .tasksSearchInput {\n    width: 40px;\n    overflow: hidden;\n    transition: width 0.3s ease;\n\n    &:focus-within {\n      width: 200px;\n    }\n\n    &:not(:focus-within) {\n      .tasksInputSearch {\n        padding: 8px 12px;\n        background: transparent;\n        border: 1px solid transparent;\n        cursor: pointer;\n\n        &::placeholder {\n          color: transparent;\n        }\n      }\n\n      .tasksSearchClear {\n        display: none;\n      }\n    }\n  }\n\n  .tasksInputSearch {\n    padding: 8px 36px 8px 12px;\n    width: 100%;\n    display: block;\n  }\n\n  .tasksSearchIcon {\n    left: 12px;\n    z-index: 2;\n  }\n\n  .tasksSearchClear {\n    right: 8px;\n  }\n\n  .tasksBtnIconSquare {\n    order: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
